import {BaseCriteriaModel} from '../../base-criteria.model';
import {Optional} from 'typescript-optional';


export class WfProjectQueryCriteriaClass extends BaseCriteriaModel{
// hdr
  namespace: Optional<string> = Optional.empty();
  module_guid: Optional<string> = Optional.empty();
  applet_guid: Optional<string> = Optional.empty();
  name: Optional<string> = Optional.empty();
  code: Optional<string> = Optional.empty();
  created_by_subject_guid: Optional<string> = Optional.empty();
  updated_by_subject_guid: Optional<string> = Optional.empty();

  //ext
  hdr_guid: Optional<string> = Optional.empty();
  line_guid: Optional<string> = Optional.empty();
  ext_type: Optional<string> = Optional.empty();
  ext_code: Optional<string> = Optional.empty();
  ext_option: Optional<string> = Optional.empty();
  param_code: Optional<string> = Optional.empty();
  param_name: Optional<string> = Optional.empty();
  param_type: Optional<string> = Optional.empty();
  value_string: Optional<string> = Optional.empty();
  value_file: Optional<string> = Optional.empty();
  value_numeric: Optional<string> = Optional.empty();

  // line
  line_type: Optional<string> = Optional.empty();
  line_code: Optional<string> = Optional.empty();
  line_option: Optional<string> = Optional.empty();

}

export class WfProjectQueryCriteriaModel {
  query = '';

  constructor(criteria: WfProjectQueryCriteriaClass) {

    if (!criteria) {
      return;
    }

    this.query += criteria.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += criteria.module_guid.filter(x => x !== '').map(x => '&module_guid=' + x).orElse('');
    this.query += criteria.applet_guid.filter(x => x !== '').map(x => '&applet_guid=' + x).orElse('');
    this.query += criteria.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += criteria.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += criteria.created_by_subject_guid.filter(x => x !== '').map(x => '&created_by_subject_guid=' + x).orElse('');
    this.query += criteria.updated_by_subject_guid.filter(x => x !== '').map(x => '&updated_by_subject_guid=' + x).orElse('');

    this.query += criteria.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += criteria.line_guid.filter(x => x !== '').map(x => '&line_guid=' + x).orElse('');
    this.query += criteria.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += criteria.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += criteria.ext_option.filter(x => x !== '').map(x => '&ext_option=' + x).orElse('');
    this.query += criteria.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += criteria.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += criteria.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += criteria.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += criteria.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += criteria.value_numeric.filter(x => x !== '').map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&orderBy=' + criteria.orderBy;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset + '&limit=' + criteria.limit;
  }

}

